import { render, staticRenderFns } from "./luckyLottery.vue?vue&type=template&id=e2cccbf2&scoped=true"
import script from "./luckyLottery.vue?vue&type=script&lang=js"
export * from "./luckyLottery.vue?vue&type=script&lang=js"
import style0 from "./luckyLottery.vue?vue&type=style&index=0&id=e2cccbf2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cccbf2",
  null
  
)

export default component.exports